import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  statusArchived: {
    id: 'publisher.status.archived',
    defaultMessage: 'Archived',
    description: 'Label on a badge element to show status.',
  },
  statusUnsubmitted: {
    id: 'publisher.status.unsubmitted',
    defaultMessage: 'Unsubmitted',
    description: 'Label on a badge element to show status.',
  },
  statusScheduled: {
    id: 'publisher.status.Scheduled',
    defaultMessage: 'Scheduled',
    description: 'Label on a badge element to show status.',
  },
  statusInReview: {
    id: 'publisher.status.inReview',
    defaultMessage: 'In review',
    description: 'Label on a badge element to show status.',
  },
  statusPublished: {
    id: 'publisher.status.published',
    defaultMessage: 'Published',
    description: 'Label on a badge element to show status.',
  },
});

export default messages;
